import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { AUTHOR } from '../../../../data/author';

function formatDate(isoDate) {
    if (!isoDate) {
        return null;
    }

    const [year, month, day] = isoDate.split('-').map((value) => Number(value));
    const date = new Date(Date.UTC(year, month - 1, day));

    return new Intl.DateTimeFormat('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'UTC'
    }).format(date);
}

const AuthorByline = ({ datePublished, dateModified, align, categoryLabel }) => {
    const publishedDate = datePublished && datePublished !== dateModified ? formatDate(datePublished) : null;
    const updatedDate = formatDate(dateModified);

    return (
        <BylineRow $align={align}>
            <MetaLabel>Written by</MetaLabel>
            <AuthorPill to={AUTHOR.path}>
                <AuthorAvatar
                    src={require('../../assets/images/founder-uros.jpg')}
                    alt="Uros, founder of Luckynote"
                    width="20"
                    height="20"
                />
                Uros
            </AuthorPill>
            <Separator aria-hidden="true">&middot;</Separator>
            <MetaText>
                {publishedDate ? (
                    <>
                        <MetaLabel>Published on</MetaLabel>{' '}
                        <MetaDate dateTime={datePublished}>{publishedDate}</MetaDate>
                    </>
                ) : null}
            </MetaText>
            {publishedDate ? <Separator aria-hidden="true">&middot;</Separator> : null}
            <MetaText>
                <MetaLabel>Updated</MetaLabel>{' '}
                <MetaDate dateTime={dateModified}>{updatedDate}</MetaDate>
            </MetaText>
            {categoryLabel ? (
                <>
                    <Separator aria-hidden="true">&middot;</Separator>
                    <MetaLabel>In</MetaLabel>
                    <CategoryPill>{categoryLabel}</CategoryPill>
                </>
            ) : null}
        </BylineRow>
    );
};

const BylineRow = styled.div`
    align-items: center;
    margin: 24px 0 0;
    color: rgba(20, 17, 15, 0.72);
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: ${({ $align }) => ($align === 'center' ? 'center' : 'flex-start')};
    text-align: left;
`;

const AuthorPill = styled(Link)`
    align-items: center;
    background: rgba(255, 255, 255, 0.74);
    border: 1px solid rgba(20, 17, 15, 0.1);
    border-radius: 10px;
    display: inline-flex;
    font-weight: 600;
    gap: 8px;
    padding: 5px 10px 5px 6px;
    text-decoration: none;

    && {
        color: #14110f;
    }

    &&:hover {
        color: #14110f;
    }
`;

const AuthorAvatar = styled.img`
    border-radius: 50%;
    height: 20px;
    object-fit: cover;
    width: 20px;
`;

const Separator = styled.span`
    color: inherit;
`;

const MetaText = styled.span`
    align-items: center;
    color: inherit;
    display: inline-flex;
    gap: 8px;
`;

const MetaLabel = styled.span`
    color: inherit;
`;

const MetaDate = styled.time`
    background: rgba(255, 255, 255, 0.74);
    border: 1px solid rgba(20, 17, 15, 0.08);
    border-radius: 8px;
    color: #14110f;
    font-weight: 600;
    padding: 6px 12px;
`;

const CategoryPill = styled.span`
    background: rgba(43, 136, 217, 0.10);
    border: 1px solid rgba(43, 136, 217, 0.08);
    border-radius: 10px;
    color: #3f7fcf;
    font-weight: 700;
    padding: 5px 10px;
`;

export default AuthorByline;
